// The ME simulation modes (the path after simulations/ for each typology). The services in src/services/api build
// their URLs with ApiEndpoints.
export const URL_ME_INDIVIDUAL = 'me-individual';
export const URL_ME_CONDOMINIUM = 'me-condominium';

export const CONFIG_HEADERS = {
    'Content-Type': 'application/json; charset=utf-8',
    cancellable: true,
    timeout: 90000, //1min5seg
};
